module.exports = __webpack_public_path__ + "static/CoinexMarket-93426cb624a6ba01f3679b22f322108d.png";